import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { App } from './app/App.jsx';
import { toast } from './store/ui.js';
import { initInstall, syncThemeColor } from './lib/install.js';

const dark = localStorage.getItem('dark') === '1';
if (dark) document.documentElement.setAttribute('data-dark', '');
syncThemeColor(dark);
initInstall();

// שגיאה שלא נתפסה (למשל שמירה שנכשלה ברקע) מוצגת למשתמש, ולא נבלעת בשקט
window.addEventListener('unhandledrejection', (ev) => {
  const m = (ev.reason && ev.reason.message) || String(ev.reason || '');
  if (m) toast('⚠️ ' + m.slice(0, 90));
  console.error('unhandled rejection:', ev.reason);
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
